var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Feedback_Active",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.266,
    height: 22.266,
    viewBox: "0 0 22.266 22.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_142893",
    "data-name": "Path 142893",
    d: "M318.712,3.479h-1.957V1.3a1.3,1.3,0,0,0-2.61,0V2.525a1.515,1.515,0,0,1-1.074,1.455l-1.1.338V11.09c0,.017,0,.034,0,.051a2.052,2.052,0,0,0,1.451.6h5.291a1.957,1.957,0,0,0,1.957-1.957V5.436A1.957,1.957,0,0,0,318.712,3.479Z",
    transform: "translate(-298.403)",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142894",
    "data-name": "Path 142894",
    d: "M223.957,88.263h-1.3a.652.652,0,0,1-.652-.652V80.652a.652.652,0,0,1,.652-.652h1.3a.652.652,0,0,1,.652.652v6.958A.652.652,0,0,1,223.957,88.263Z",
    transform: "translate(-212.346 -76.521)",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142895",
    "data-name": "Path 142895",
    d: "M15.018,182.349a3.331,3.331,0,0,1-1.965-.635,1.952,1.952,0,0,1-1.442.635h-1.3a1.957,1.957,0,0,1-1.957-1.957V177H.652a.652.652,0,0,0-.652.652V190.9a.673.673,0,0,0,.3.572.652.652,0,0,0,.71-.009l2.445-1.63H17.178a.652.652,0,0,0,.652-.652v-6.828ZM3.262,180.262h3.7a.652.652,0,1,1,0,1.3h-3.7a.652.652,0,1,1,0-1.3Zm11.307,7.176H3.262a.652.652,0,1,1,0-1.3H14.569a.652.652,0,1,1,0,1.3Zm0-2.935H3.262a.652.652,0,0,1,0-1.3H14.569a.652.652,0,0,1,0,1.3Z",
    transform: "translate(0 -169.303)",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackActive);
export default __webpack_public_path__ + "static/media/feedback_active.4aca4b27.svg";
export { ForwardRef as ReactComponent };